import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import ls from "local-storage";
import styled from "styled-components";

import falk_ from "../../assets/images/falk_.png";
import icn_img from "../../assets/images/icn.svg";
import pdf_img from "../../assets/images/pdf.svg";
import { Button } from "../ui-kit/styled-templates";

import top_stats_im0 from "../../assets/images/top_stats_im0.png";
import bottom_stats_im0 from "../../assets/images/bottom_stats_im0.png";

import falk_square from "../../assets/images/falk_square.jpg";
import PartnersListTool from "../partners/tools/PartnersListTool";

import im_00_1 from "../../assets/images/im_00_1.png";
import im_00_2 from "../../assets/images/img_00_2.png";
import im_00_3 from "../../assets/images/im_00_3.png";

import rect_01_img from "../../assets/images/np_01.jpg";
import rect_02_img from "../../assets/images/prof_01.jpg";
import rect_03_img from "../../assets/images/kul_01.jpg";

const AboutProgramPage2 = () => {

    const [bigUrl, setBigUrl] = useState(undefined);
    const { t, i18n } = useTranslation();

    let isRu = i18n.language == "ru";
    let isEn = i18n.language == "en";

    return (
        <OuterWrapper className={"about_page"}>
            <Wrapper>

                <TopQuote className={"falk_quote"}>

                    <LeftFalk className={"falk_left"}>
                        <FalkImg
                            src={falk_square}
                        />


                        {isRu &&
                            <>
                                <Falk className={""}>
                                    Министр науки и высшего образования Российской Федерации
                                    <br />
                                    <b>
                                        Фальков В.Н.
                                    </b>
                                </Falk>
                            </>
                        }

                        {isEn &&
                            <>
                                <Falk className={""}>
                                    Minister of Science and Higher Education of the Russian Federation
                                    <br />
                                    <b>
                                        Valery  Falkov
                                    </b>
                                </Falk>
                            </>
                        }


                    </LeftFalk>

                    <TopRightQuote style={{ fontFamily: "'Noto Sans', sans-serif" }} className={"falk_right"}>

                        {isRu &&
                            <>
                                Студенческий туризм — это не просто путешествия по России.
                                Это толчок для профессионального роста, личного и научного сотрудничества — отправная
                                точка
                                совместных научных и технологических проектов.
                            </>
                        }
                        {isEn &&
                            <>
                                Student tourism is not just about traveling across Russia.
                                It's a boost for professional development, personal and academic collaboration—a
                                starting point for joint scientific and technological projects.
                            </>
                        }


                    </TopRightQuote>
                </TopQuote>

                {/*<TopImg src={falk_} />*/}

                {/*<TopPlaceholder>*/}
                {/*    <SupTopPlaceholder>*/}
                {/*        <BackLink href={"/"}>{t("2hl4zhkeu8l")}</BackLink>*/}
                {/*    </SupTopPlaceholder>*/}
                {/*    <Heading>{t("t5bifjs6fjh")}</Heading>*/}
                {/*</TopPlaceholder>*/}

                <NewContent>
                    {/*<div>*/}
                    {/*    <b>ЦЕЛЬ</b> – создание единого пространства для культурного, профессионального и личностного*/}
                    {/*    развития молодежи в России*/}
                    {/*</div>*/}

                    <TripletPlaceholder className={"about_triplet_placeholder"}>
                        <TripletItem className={""} style={{ paddingRight: "0px" }}>
                            <Heading50>
                                {isRu ? 'Цель' : 'Goal'}
                            </Heading50>
                        </TripletItem>
                        <TripletItem style={{ flex: 2, paddingLeft: "0px" }}>
                            <div style={{ fontFamily: "'Noto Sans', sans-serif" }}>
                                {isRu ? 'Cоздание единого пространства для культурного, профессионального и личностного развития молодежи в России': 'Creating a single space for the cultural, professional and personal development of young people in Russia'}
                            </div>
                            {/*/!*<TripletHeading>*!/*/}
                            {/*/!*    Cоздание единого пространства для культурного, профессионального и личностного*!/*/}
                            {/*/!*    развития молодежи в России*!/*/}
                            {/*/!*</TripletHeading>*!/*/}
                            {/*<TripletSub>*/}
                            {/*    Cоздание единого пространства для культурного, профессионального и личностного*/}
                            {/*    развития молодежи в России*/}
                            {/*</TripletSub>*/}
                        </TripletItem>

                    </TripletPlaceholder>

                    <TripletPlaceholder className={"about_triplet_placeholder"}>
                        <TripletItem>
                            <TripletHeading>
                                110+
                            </TripletHeading>
                            <TripletSub>
                                {isRu ? 'городов' : 'cities'}
                            </TripletSub>
                        </TripletItem>
                        <TripletItem>
                            <TripletHeading>
                                230+
                            </TripletHeading>
                            <TripletSub>
                                {isRu ? 'университетов' : 'universities'}
                            </TripletSub>
                        </TripletItem>
                        <TripletItem>
                            <TripletHeading>
                                83+
                            </TripletHeading>
                            <TripletSub>
                                {isRu ? 'субъекта РФ' : 'regions'}
                            </TripletSub>
                        </TripletItem>
                    </TripletPlaceholder>

                    <StH style={{
                        textAlign: "left",
                        marginTop: 60,
                        marginBottom: 60,
                        fontFamily: "'Noto Sans', sans-serif"
                    }}>
                        {isRu ? 'Стань участником Программы, если ты:' : 'Become a participant in the Program if you:'}
                    </StH>

                    <div style={{ marginTop: 20, marginBottom: 40 }}>
                        {/*<img*/}
                        {/*    style={{ width: "100%" }}*/}
                        {/*    src={bottom_stats_im0}*/}
                        {/*/>*/}

                        <TripletTypesPlaceholder>
                            {[
                                {
                                    name: isRu ? "Обучающийся университета" : "University student",
                                    image: im_00_1,
                                    subDescription: ""
                                },
                                {
                                    name: isRu ? "Аспирант или молодой ученый" : "Graduate student or young scientist",
                                    image: im_00_2,
                                    subDescription: isRu ? "до 35 лет" : "up to 35 years"
                                },
                                {
                                    name: isRu ? "Молодой специалист" : "Young specialist",
                                    image: im_00_3,
                                    subDescription: isRu ? "до 35 лет" : "up to 35 years"
                                }
                            ].map((a, i) => {
                                return (<div style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    fontSize: "24px"
                                }}>
                                    <ProImg src={a.image} style={{ marginRight: "10px" }} />
                                    <div style={{ paddingTop: "10px" }}>
                                        <ProName>
                                            {a.name}
                                        </ProName>
                                        {a.subDescription == "" ? null :
                                            <ProDescription style={{ color: "rgb(114, 61, 210, 0.7)" }}>
                                                {a.subDescription}
                                            </ProDescription>
                                        }
                                    </div>
                                </div>);
                            })}
                        </TripletTypesPlaceholder>

                    </div>

                    <StH style={{ fontFamily: "'Noto Sans', sans-serif", lineHeight: "80px", marginBottom: 10 }}>
                        {isRu ? 'Направления программы' : 'Program directions'}
                    </StH>

                    <TripletTypesPlaceholder>
                        {[
                            {
                                name: isRu ? "Научно-популярное" : "Scientific and popular",
                                image: rect_01_img,
                                subDescription: isRu ? "участие в научных мероприятиях, написание научных работ" : "participation in scientific events, writing scientific papers"
                            },
                            {
                                name: isRu ? "Профориентационное" : "Career guidance",
                                image: rect_02_img,
                                subDescription: isRu ? "погружение в специальности, смена направления обучения" : "immersion in the specialty, changing the direction of study"
                            },
                            {
                                name: isRu ? "Культурно-познавательное" : "Cultural and cognitive",
                                image: rect_03_img,
                                subDescription: (<>культурное и личностное <br /> развитие </>)
                            }
                        ].map((a, i) => {
                            return (<TripetTypeItem>
                                <TripletImage src={a.image} style={{ height: "300px", objectFit: "cover" }} />
                                <TripletTextPlaceholder>
                                    <TripletText>
                                        {a.name}
                                    </TripletText>
                                </TripletTextPlaceholder>
                            </TripetTypeItem>);
                        })}
                    </TripletTypesPlaceholder>

                    {/*<PartnersListTool*/}
                    {/*    is50={false}*/}
                    {/*    knowMore={false}*/}
                    {/*    isGreen={true}*/}
                    {/*    cursor={'default'}*/}
                    {/*    partners={[*/}
                    {/*        {*/}
                    {/*            name: "Научно-популярное",*/}
                    {/*            image: rect_01_img,*/}
                    {/*            subDescription: "участие в научных мероприятиях, написание научных работ"*/}
                    {/*        },*/}
                    {/*        {*/}
                    {/*            name: "Профориентационное",*/}
                    {/*            image: rect_02_img,*/}
                    {/*            subDescription: "погружение в специальности, смена направления обучения"*/}
                    {/*        },*/}
                    {/*        {*/}
                    {/*            name: "Культурно-познавательное",*/}
                    {/*            image: rect_03_img,*/}
                    {/*            subDescription: (<>культурное и личностное <br /> развитие </>)*/}
                    {/*        }*/}
                    {/*    ]}*/}
                    {/*/>*/}

                    <TripletPlaceholder className={"about_triplet_placeholder"}>
                        <TripletItem>
                            <Heading50>
                                {isRu ? 'Отправляйся в путешествие' : 'Go on a journey'}
                            </Heading50>
                        </TripletItem>
                        <TripletItem>
                            <TripletHeading>

                            </TripletHeading>
                            <TripletSub style={{ fontSize: "24px" }}>
                                <StH>
                                    {isRu ? 'В составе организованной группы' : 'As part of an organized group'}
                                </StH>
                            </TripletSub>
                        </TripletItem>
                        <TripletItem>
                            <TripletHeading>

                            </TripletHeading>
                            <TripletSub style={{ fontSize: "24px" }}>
                                <StH>
                                    {isRu ? 'Самостоятельно' : 'Independently'}
                                </StH>
                            </TripletSub>
                        </TripletItem>
                    </TripletPlaceholder>

                    <TripletPlaceholder className={"about_triplet_placeholder"}>
                        <TripletItem>
                            <Heading50>
                                {isRu ? 'О Программе' : 'About the Program'}
                            </Heading50>
                        </TripletItem>
                        <TripletItem style={{ flex: 2, paddingLeft: "0px" }}>
                            <div style={{ fontFamily: "'Noto Sans', sans-serif" }}>
                                {isRu ?
                                    <>
                                        Программа Студтуризм была запущена в 2021 году. Она убедительно доказала своевременность
                                        и востребованность в молодежной среде,
                                        продемонстрировала готовность к системному масштабированию результатов и позитивных
                                        социальных эффектов.
                                        С тех пор молодые люди ежегодно отправляются в путешествия от Калининграда до
                                        Владивостока, ведь университеты по
                                        всей стране открывают двери своих кампусов для проживания путешественников. Участники
                                        Программы могут выбрать уникальные
                                        туристические программы, разработанные в формате «студент-студенту», объекты и маршруты
                                        научно-популярного туризма, события и многое другое.
                                    </>
                                    :
                                    <>
                                        The Student Tourism Program was launched in 2021. It convincingly demonstrated its
                                        timeliness and relevance in the youth environment,
                                        demonstrated readiness for systematic scaling of results and positive social effects.
                                        Since then, young people have been traveling annually from Kaliningrad to
                                        Vladivostok, as universities across the country open the doors of their campuses for
                                        travelers. Program participants can choose unique
                                        tourist programs developed in the format of "student-to-student", objects and routes of
                                        scientific and popular tourism, events and much more.
                                    </>
                                }

                                {/*Программа была запущена в 2021 году, став импульсом развития внутреннего студенческого*/}
                                {/*туризма в России.*/}
                                {/*Она убедительно доказала своевременность и востребованность в молодежной среде,*/}
                                {/*продемонстрировала готовность к системному масштабированию результатов и позитивных*/}
                                {/*социальных эффектов. Молодые люди ежегодно отправляются в путешествия от Калининграда до*/}
                                {/*Владивостока, ведь вузы по всей стране распахнули двери кампусов для молодых людей.*/}
                                {/*Участникам предлагаются уникальные туристические программы, разработанных в формате*/}
                                {/*«студент-студенту», научно-популярные объекты показов и события.*/}
                            </div>
                        </TripletItem>

                    </TripletPlaceholder>

                    <TripletPlaceholder className={"about_triplet_placeholder"}>
                        <TripletItem>
                            <Heading50>
                                {isRu ?
                                    <>
                                        Алгоритм
                                        <br />
                                        действий
                                    </>
                                    :
                                    <>
                                        Action
                                        <br />
                                        algorithm
                                    </>
                                }

                            </Heading50>
                        </TripletItem>

                        <TripletItem style={{ flex: 2, paddingLeft: "0px" }}>
                            <div style={{ fontFamily: "'Noto Sans', sans-serif", paddingLeft: "0px" }}>

                                <RightItemsList>

                                    {[
                                        {
                                            name: isRu ? "Определи" : "Define",
                                            description: isRu ?  "цель своего путешествия и выбери направление (регион)" : "the purpose of your trip and choose a direction (region)"
                                        },
                                        {
                                            name: isRu ? "Забронируй" : "Book",
                                            description: isRu ? "размещение на нужные даты в кампусе или общежитии университета" : "accommodation on the required dates in the campus or dormitory of the university"
                                        },
                                        {
                                            name: isRu ? "Получи" : "Get",
                                            description: isRu ?  "подтверждение от принимающего университета" : "confirmation from the receiving university"
                                        },
                                        {
                                            name: isRu ? "Отправляйся в путь, " : "Go on a journey,",
                                            description: isRu ? "знакомься с культурой региона, развивайся личностно и профессионально, получай новые эмоции" : "get to know the culture of the region, develop personally and professionally, get new emotions"
                                        },
                                        {
                                            name: isRu ? "Не забывай" : "Don't forget",
                                            description: isRu ? "оставлять свои отзывы в социальных сетях с хэштегом #CТУДТУРИЗМ и официальном <a href='https://t.me/studturism'>Телеграм-канале</a> Программы" : "to leave your reviews on social networks with the hashtag #CТУДТУРИЗМ and the official <a href='https://t.me/studturism'>Telegram channel</a> of the Program"
                                        },
                                        {
                                            name: isRu ? "Возвращайся" : "Come back",
                                            description: isRu ? "за новым путешествием, выбирай свой путь!" : "for a new journey, choose your own path!"
                                        }
                                    ].map((a, i) => {
                                        return (
                                            <RightItem key={i}>
                                                <RightItemFirst>
                                                    {`${+i + 1}`}
                                                </RightItemFirst>
                                                <RightItemSecond>
                                                    <b style={{ marginRight: "7px" }}>
                                                        {a.name}
                                                    </b>
                                                    <span style={{ marginLeft: "3px" }}
                                                          dangerouslySetInnerHTML={{ __html: a.description }}>

                                                    </span>
                                                </RightItemSecond>
                                                {/*<RightItemThird>*/}
                                                {/*    {a.description}*/}
                                                {/*</RightItemThird>*/}
                                            </RightItem>
                                        );
                                    })}

                                </RightItemsList>


                            </div>
                        </TripletItem>

                    </TripletPlaceholder>

                    <RightHeading>
                        {/*{t("3yb0iog58ss")}*/}
                        {isRu ? 'Документы' : 'Documents'}
                    </RightHeading>

                    <div style={{ display: "flex", flexDirection: "row" }} className={"bottom_docs_placeholder"}>

                        <RightBox style={{ flex: 1, marginRight: 20 }} className={"docs_placeholder"}>
                            <RightContentPlaceholder>

                                {[
                                    {
                                        label: t("7imzdyul3yc"),
                                        subLabel: t("3kv5044chao"),
                                        url: "./polozhenie.pdf"
                                    },
                                    {
                                        label: t("ei52hitiia"),
                                        subLabel: t("jsdbhbl2koj"),
                                        url: "./doc_l1.pdf"
                                    },
                                    {
                                        label: t("qc4fd0ey3f"),
                                        subLabel: t("prw384jntr"),
                                        url: "./doc_l2.pdf"
                                    }

                                ].map((a, i) => {
                                    return (
                                        <FileItem
                                            key={i}
                                            onClick={() => {
                                                window.open(a.url, "_blank").focus();
                                            }}
                                        >
                                            <FileImg src={pdf_img} />
                                            <FileItemContent>
                                                <FileItemLeft>
                                                    <FileItemHeading>{a.label}</FileItemHeading>
                                                    <FileItemSubHeading>{a.subLabel}</FileItemSubHeading>
                                                </FileItemLeft>
                                                <FileItemRight>
                                                    <DownImg src={icn_img} />
                                                </FileItemRight>
                                            </FileItemContent>
                                        </FileItem>
                                    );
                                })}
                            </RightContentPlaceholder>
                        </RightBox>

                        <RightBox style={{ flex: 1, marginRight: 20 }} className={"docs_placeholder"}>

                            <RightContentPlaceholder>

                                {[

                                    // {
                                    //     label: "План мероприятий научно-популярно туризма до 2024 г.",
                                    //     subLabel: "Мероприятия нп туризма.pdf",
                                    //     url: "./mer_np_t.pdf"
                                    // },
                                    {
                                        label: t("turclub_doc_name"),
                                        subLabel: t("turclub_doc_description"),
                                        url: "./metod_stud_club.pdf"
                                    },
                                    {
                                        label: "Всероссийский реестр  научно-популярного туризма",
                                        subLabel: "Реестр нп объектов.pdf",
                                        // url: "./reestr_np.pdf"
                                        url: "./npreestr.xlsx"
                                    },
                                    {
                                        label: "Концепция развития научно-популярного туризма в РФ",
                                        subLabel: "Концепция от 25.01.2023.pdf",
                                        url: "./concept_2023.pdf"
                                    }
                                ].map((a, i) => {
                                    return (
                                        <FileItem
                                            key={i}
                                            onClick={() => {
                                                window.open(a.url, "_blank").focus();
                                            }}
                                        >
                                            <FileImg src={pdf_img} />
                                            <FileItemContent>
                                                <FileItemLeft>
                                                    <FileItemHeading>{a.label}</FileItemHeading>
                                                    <FileItemSubHeading>{a.subLabel}</FileItemSubHeading>
                                                </FileItemLeft>
                                                <FileItemRight>
                                                    <DownImg src={icn_img} />
                                                </FileItemRight>
                                            </FileItemContent>
                                        </FileItem>
                                    );
                                })}
                            </RightContentPlaceholder>
                        </RightBox>


                    </div>


                </NewContent>

            </Wrapper>

            {bigUrl == undefined ? null : (
                <GlobalWarningPlaceholder>
                    <WhiteBox>
                        <img src={bigUrl} style={{ width: "100%" }} />

                        <WarningButtonPlaceholder>
                            <Button
                                onClick={() => {
                                    ls("first-visit-warning", false);
                                    setBigUrl(undefined);
                                }}
                            >
                                {t("k6a0kbmm5p")}
                            </Button>
                        </WarningButtonPlaceholder>
                    </WhiteBox>
                </GlobalWarningPlaceholder>
            )}
        </OuterWrapper>
    );
};

const StH = styled.div`
  font-size: 24px;
  @media (max-width: 800px) {
    font-size: 20px;
  }
`;

const ProImg = styled.img`
  height: 160px;
  @media (max-width: 820px) {
    height: 100px;
  }
`;

const Heading50 = styled.div`
  //font-size: 50px;
  font-size: 36px;
  line-height: 58px;
  font-family: "Noto Sans", sans-serif;
  @media (max-width: 1200px) {
    font-size: 34px;
    line-height: 40px;
  }
`;

const ProDescription = styled.div`
  margin-top: 5px;
  @media (max-width: 800px) {
    font-size: 18px;
    margin-top: 0px;
  }
`;

const ProName = styled.div`
  font-size: 24px;
  line-height: 36px;
  padding-right: 20px;
  @media (max-width: 1200px) {
    font-size: 20px;
    line-height: 22px;
  }
`;

const Heading30 = styled.div`
  font-size: 24px;
  line-height: 36px;
  padding-right: 40px;
  @media (max-width: 1200px) {
    font-size: 24px;
    line-height: 30px;
  }
`;

const TripletTypesPlaceholder = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  @media (max-width: 800px) {
    display: block;
  }
`;

const BotItem = styled.div`
  display: flex;
  flex-direction: row;
`;

const TripetTypeItem = styled.div`
  box-sizing: border-box;
  flex: 1;
  padding: 10px;
  position: relative;
  height: 300px;
  width: 33.33%;

  @media (max-width: 1200px) {
    display: block;
    width: 50%;
  }

  @media (max-width: 800px) {
    display: block;
    width: 100%;
    margin-bottom: 10px;
  }
`;

const TripletImage = styled.img`
  box-sizing: border-box;
  width: 100%;
  height: 100%;
`;

const TripletTextPlaceholder = styled.div`
  display: flex;
  flex-direction: row;
  position: absolute;
  left: 15px;
  bottom: 15px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 5px;
`;

const TripletText = styled.div`
  color: black;
  padding-left: 10px;
  padding-right: 10px;
  line-height: 32px;
`;

const RightItemsList = styled.div`

`;

const RightItem = styled.div`
  display: flex;
  flex-direction: row;
  padding-top: 20px;
  padding-bottom: 20px;
  font-family: "Noto Sans", sans-serif;
  text-align: left;
`;

const RightItemFirst = styled.div`
  width: 70px;
  min-width: 70px;
  //marginRight: 20px;
  font-family: "Noto Sans", sans-serif;
  fontSize: 72px;
  text-align: left;
  opacity: 0.5;
  @media (max-width: 800px) {
    width: 40px;
    min-width: 40px;
  }
`;

const RightItemSecond = styled.div`
  box-sizing: border-box;
  //padding-left: 20px;
  text-align: left;
  //padding-right: 20px;
  //width: 300px;
  font-family: "Noto Sans", sans-serif;
  @media (max-width: 800px) {
    font-size: 18px;
  }
  //font-weight: bold;
`;

const RightItemThird = styled.div`
  flex: 1;
  font-family: "Noto Sans", sans-serif;
  font-size: 24px;
  line-height: 28px;
`;

const FirstInnerTd = styled.div`
  padding-right: 30px;
`;

const SecondInnerTd = styled.div`
  opacity: 0.5;
  font-style: italic;
  font-size: 20px;
`;

const TopQuote = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 50px;
`;

const TopRightQuote = styled.div`
  text-align: justify;
  font-family: "Noto Sans", sans-serif;
  font-size: 24px;
  line-height: 40px;
  margin-left: 40px;
  margin-top: -70px;
  //margin-bottom: 50px;
  //width: 620px;
  flex: 1;
  font-style: italic;
  @media (max-width: 1200px) {
    margin-top: 0px;
  }
  @media (max-width: 800px) {
    font-size: 20px !important;
  }

`;

const LeftFalk = styled.div`
  //flex: 1;
  padding-right: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 400px;
  @media (max-width: 1200px) {
    //width: 100%;
    width: 300px;
    padding-right: 0px;
  }
  @media (max-width: 800px) {
    width: 100%;
  }
`;

const FalkImg = styled.img`
  width: 180px;
  height: 180px;
  border-radius: 1000px;
`;

const Falk = styled.div`
  //font-style: italic;
  font-size: 16px;
  padding: 20px;
  text-align: center;
  font-family: "Noto Sans", sans-serif;
`;

const TopImg = styled.img`
  display: block;
  width: 100%;
  @media (max-width: 820px) {
    display: none;
  }
`;

const GlobalWarningPlaceholder = styled.div`
  position: fixed;
  z-index: 100;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  background: rgba(0, 0, 0, 0.5);
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const WhiteBox = styled.div`
  padding: 20px;
  border-radius: 8px;
  text-align: justify;
  background: white;
  width: 620px;
  box-sizing: border-box;
  @media (max-width: 620px) {
    width: calc(100vw - 40px);
    padding: 10px;
  }
`;

const WarningButtonPlaceholder = styled.div`
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const LoImg = styled.div`
  width: 240px;
  height: 240px;
  box-sizing: border-box;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url(${(props) => props.src});
  margin: 10px;
  cursor: pointer;
`;

const Ul = styled.ul`
  box-sizing: border-box;
  padding-left: 15px;
  margin-bottom: 25px;
`;

const Li = styled.li`
  margin-bottom: 10px;
  box-sizing: border-box;
`;

const Heading2 = styled.div`
  font-family: "Noto Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 27px;
  color: #212121;
`;

const BLabel = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #212529;
  font-family: "Noto Sans", sans-serif;
`;

const DownImg = styled.img`
  height: 24px;
  cursor: pointer;
`;

const FileItemHeading = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 20px;
  color: #212529;
  font-family: "Noto Sans", sans-serif;
`;

const FileItemSubHeading = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  color: #aaaaaa;
  font-family: "Noto Sans", sans-serif;
`;

const RightContentPlaceholder = styled.div``;

const MyP = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  color: #212529;
  margin-bottom: 15px;
`;

const FileItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 20px;
  cursor: pointer;
`;

const FileItemContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const FileItemLeft = styled.div`
  flex: 1;
`;

const FileItemRight = styled.div``;

const FileImg = styled.img`
  height: 40px;
  margin-right: 8px;
`;

const RightHeading = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 27px;
  font-family: "Noto Sans", sans-serif;
  margin-bottom: 20px;
`;

const Left = styled.div`
  flex: 1;
  @media (max-width: 800px) {
    margin-left: 0px;
    padding: 5px;
  }
`;

const Right = styled.div`
  width: 380px;
  margin-left: 40px;
  @media (max-width: 800px) {
    margin-left: 0px;
    padding: 5px;
  }
`;

const RightBox = styled.div`
  //background: #f4f9fc;
  background: rgb(237, 231, 227);
  border-radius: 12px;
  box-sizing: border-box;
  padding: 32px;
  margin-bottom: 32px;
  @media (max-width: 800px) {
    padding: 20px;
  }
`;

const TripletPlaceholder = styled.div`
  display: flex;
  flex-direction: row;
  font-family: "Noto Sans", sans-serif;
  margin-top: 40px;
  margin-bottom: 40px;
`;

const TripletHeading = styled.div`
  font-size: 50px;
  line-height: 72px;
  font-weight: bold;
  padding-top: 20px;
  border-top: 2px solid lightgrey;
  color: #723DD3;
  font-family: "Noto Sans", sans-serif;
  @media (max-width: 1200px) {
    font-size: 42px;
  }
`;

const TripletSub = styled.div`
  font-size: 28px;
  opacity: 0.5;
  font-family: "Noto Sans", sans-serif;
  @media (max-width: 800px) {
    font-size: 20px;
  }
`;

const TripletItem = styled.div`
  flex: 1;
  padding: 40px;
  text-align: left;
  padding-left: 10px;

  :first-of-type {

  }

  @media (max-width: 800px) {
    font-size: 20px;
    padding-bottom: 10px;
  }
`;

const NewContent = styled.div`
  font-family: "Noto Sans", sans-serif;
  font-size: 24px;
  line-height: 32px;
`;

const ContentPlaceholder = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  @media (max-width: 800px) {
    display: block;
  }
`;

const BackLink = styled.a`
  text-decoration: none;
  color: ${({ theme }) => theme.grey};
  cursor: pointer;
`;

const OuterWrapper = styled.div`
  width: 100%;
  background: white;
  padding-top: 30px;
  box-sizing: border-box;
  padding-bottom: 40px;
`;

const Wrapper = styled.div`
  text-align: left;
  box-sizing: border-box;
  width: 1400px;
  margin: 0 auto;
  padding: 15px;
  @media (max-width: 1400px) {
    width: 100%;
  }
  @media (max-width: 800px) {
    font-size: 20px;
  }
`;

const Heading = styled.div`
  font-family: "Noto Sans", sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 56px;
  line-height: 72px;
  margin-bottom: 40px;
  @media (max-width: 820px) {
    font-size: 24px;
    line-height: 32px;
    padding-left: 5px;
  }
`;

const SupTopPlaceholder = styled.div`
  margin-bottom: 20px;
`;

const TopPlaceholder = styled.div``;

export default AboutProgramPage2;
